var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12C19 12.2652 18.9115 12.5196 18.754 12.7071C18.5964 12.8946 18.3828 13 18.16 13H5.84C5.61722 13 5.40356 12.8946 5.24603 12.7071C5.0885 12.5196 5 12.2652 5 12C5 11.7348 5.0885 11.4804 5.24603 11.2929C5.40356 11.1054 5.61722 11 5.84 11H18.16C18.3828 11 18.5964 11.1054 18.754 11.2929C18.9115 11.4804 19 11.7348 19 12Z",
    fill: "#24262E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/Minus.eaff813058a853479fd9cc326c54c364.svg";
export { ForwardRef as ReactComponent };